module.exports = __webpack_public_path__ + "static/media/dev-icon.c72b40c7.svg";